import React from 'react';
import {push, replace} from 'react-router-redux';

import {
    ROUTE_HOME,
    ROUTE_DASHBOARD,
    ROUTE_REPORTING,
    ROUTE_CLUBS,
    ROUTE_CLUB,
    ROUTE_MEMBERS,
    ROUTE_SECTIONS,
    ROUTE_RACES,
    ROUTE_STATIONS,
    ROUTE_RANGES,
    ROUTE_ZIPS,
    ROUTE_NIGHT_TIMES,
    ROUTE_DERBYS,
    ROUTE_ERROR_LISTS,
    ROUTE_SETTINGS,
    ROUTE_CHAMPIONSHIPS
} from '../../../constants/routeconstants';
import { connect } from 'react-redux';
import UserRoles from "../../../../../common/src/enums/UserRoles";
import {Link} from "react-router";

import * as AdminActions from "../../../actions/admin";

import ExportDialog from './dialogs/ExportDialog';
import ImportFilesDialog from './dialogs/ImportFilesDialog';
import RacesInvoiceDialog from './dialogs/RacesInvoiceDialog';
import RestoreFromBackupDialog from './dialogs/RestoreFromBackupDialog';
import StartSeasonDialog from './dialogs/StartSeasonDialog';
import ImportDevicesDialog from './dialogs/ImportDevicesDialog';
import {NotificationManager} from "react-notifications";
import UserFieldDataType from "../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from "../../reusable/UserFieldElement";
import config from "../../../../../server/src/config";
import {confirm} from "../../../utils/confirmDialog";
import moment from "moment";
import * as RaceActions from "../../../actions/race";
import ExportSignupsAndResultsDialog from "./dialogs/ExportSignupsAndResultsDialog";
import ImportMemberProgramDialog from "./dialogs/ImportMemberProgramDialog";
import ExportDevicesDialog from "./dialogs/ExportDevicesDialog";
import client from "../../../utils/ajax/client";
import * as GlobalErrorActions from "../../../actions/globalerror";

class Dashboard extends React.Component {

    static getId() {
        return ROUTE_DASHBOARD;
    }

    static getAllowedRoles() {
        return [UserRoles.USER, UserRoles.CLUB_ADMIN, UserRoles.SECTION_ADMIN, UserRoles.MAIN_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            showExportDevicesDialog: false,
            showExportDialog: false,
            showImportDialog: false,
            showRacesInvoiceDialog: false,
            showRestoreFromBackupDialog: false,
            showStartSeasonDialog: false,
            showImportMemberProgramDialog: false,
            showImportDevicesDialog: false,
            showSendDialog: false,
        }
    }

    componentDidMount() {
        if (!this.props.auth.isAuthenticated) this.props.dispatch(replace(ROUTE_HOME));
        else this.props.dispatch(AdminActions.getDashboardData());
        if (typeof(this.props.location.query.message) !== 'undefined') {
            const title = typeof(this.props.location.query.title) === 'undefined' ? 'Info' : this.props.location.query.title;
            if (typeof(this.props.location.query.status) !== 'undefined' && this.props.location.query.status === 'error') NotificationManager.error(this.props.location.query.message, title, 0);
            else if (typeof(this.props.location.query.status) !== 'undefined' && this.props.location.query.status === 'warning') NotificationManager.warning(this.props.location.query.message, title, 10000);
            else NotificationManager.success(this.props.location.query.message, title, 4000);
            this.props.dispatch(push(ROUTE_DASHBOARD));
        }
    }

    componentDidUpdate(prevProps) {
        if ((this.props.auth.currentRole === null || this.props.auth.currentRole === UserRoles.USER.id) && this.props.admin.userRoles.length === 1 && prevProps.admin.userRoles.length === 0) {
            const role = this.props.admin.userRoles[0];
            const roleId = role.level === UserRoles.MAIN_ADMIN.id ? "m" : role.level === UserRoles.SECTION_ADMIN.id ? "s" + role.id : "c" + role.id
            this.props.dispatch(AdminActions.selectUserRole(roleId));
        }
    }

    render() {
        return (
            <div className="dashboard-page">
                <div className="sub-page-title">
                    <h2 className="display-inline-block">Hovedmenu</h2>
                    {!this.props.admin.userRoles || this.props.admin.userRoles.length < 1 || (this.props.admin.userRoles.length === 1 && (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id || this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id || this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id)) ? null : <div className="float-right display-inline-block">
                        <UserFieldElement dataType={UserFieldDataType.enum} placeholder={this.props.auth.currentRole !== UserRoles.CLUB_ADMIN.id && this.props.auth.currentRole !== UserRoles.SECTION_ADMIN.id && this.props.auth.currentRole !== UserRoles.MAIN_ADMIN.id ? "-- Vælg --" : false} className="field300"
                                          name="select-user-role" id="select-user-role"
                                          value={this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? "m" : this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id ? "s" + this.props.auth.currentEntity : this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? "c" + this.props.auth.currentEntity : ''}
                                          options={this.props.admin.userRoles.map(role => ({
                                              key: role.level === UserRoles.MAIN_ADMIN.id ? "m" : role.level === UserRoles.SECTION_ADMIN.id ? "s" + role.id : "c" + role.id,
                                              value: role.level === UserRoles.MAIN_ADMIN.id ? "DDB" : role.id + " - " + role.name,
                                          }))}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={(e) => {
                                              const role = e.target.value;
                                              this.props.dispatch(AdminActions.selectUserRole(role, () => {
                                                  NotificationManager.success('Du har nu skiftet rolle.', 'Ny rolle', 4000);
                                              }));
                                          }}
                        />
                    </div>}
                </div>
                <div className="sub-page-content">
                    <table className="dashboard-table dashboard-table-1">
                        <tbody>
                            <tr>
                                <td><h3>Administration</h3></td>
                                <td><h3>Kapflyvninger</h3></td>
                                <td><h3>Sæsonafslutning</h3></td>
                            </tr>
                            <tr>
                                <td>
                                    {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id || this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id || this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <Link className="btn-primary" to={this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? ROUTE_CLUB.replace(':clubNo', this.props.auth.currentEntity).replace(':subpage', 'general').replace(':mode', 'view') : ROUTE_CLUBS}
                                                  title="Administrer foreningsdata">
                                                Foreninger
                                            </Link>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <Link className="btn-primary" to={ROUTE_MEMBERS}
                                                  title="Administrer medlemsdata og søg på medlemmer">
                                                Medlemmer
                                            </Link>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id || this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id || this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <Link className="btn-secondary" to={ROUTE_SETTINGS.replace(":subpage", this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? "deposits" : "general").replace(":sectionNo", this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? "ddb" : this.props.auth.currentEntity).replace(":mode", "view")} title="Vedligehold indskud, markeringer og præmier">
                                                Indstillinger
                                            </Link>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id || this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id || this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-separator"/>: null
                                    }
                                    {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ?
                                        <div className="link-container">
                                            <a className="dashboard-link" href="#" title="Udlæs duebestand til elektroniske udstyr"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   this.props.dispatch(AdminActions.getClub(this.props.auth.currentEntity));
                                                   this.setState({showExportDevicesDialog: true})
                                               }
                                               }>Eksporter til udstyr</a>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <Link className="dashboard-link" to={ROUTE_SECTIONS}
                                                  title="Vedligehold sektionsdatadata">Sektioner</Link>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <Link className="dashboard-link" to={ROUTE_RANGES}
                                                  title="Vedligehold områder">Områder</Link>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id || this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id || this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <Link className="dashboard-link" to={ROUTE_STATIONS}
                                                  title="Vedligehold stationer">Stationer</Link>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <Link className="dashboard-link" to={ROUTE_ZIPS}
                                                  title="Vedligehold postnumre">Postnumre</Link>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <Link className="dashboard-link" to={ROUTE_NIGHT_TIMES}
                                                  title="Vedligehold nattider">Nattider</Link>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <Link className="dashboard-link" to={ROUTE_DERBYS}
                                                  title="Vedligehold derby">Derby</Link>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-separator"/> : null
                                    }
                                    {/*this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <a className="dashboard-link" href="#"
                                               title="Eksporter til foreningsprogram" onClick={(e) => {
                                                e.preventDefault();
                                                this.setState({showExportDialog: 'races'})
                                            }
                                            }>Eksporter</a>
                                        </div> : null
                                    */}
                                    {/*this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-separator"/> : null
                                    */}
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <form id="get-backup-form" action={"/api/admin/download-backup"}
                                                  target="_blank" method="post">
                                                <a className="dashboard-link" href="#" title="Download databasebackup"
                                                   onClick={(e) => {
                                                       if (this.props.auth.database === 'standard') {
                                                           e.preventDefault();
                                                           document.getElementById('get-backup-form').submit();
                                                       } else confirm("Backup", <span>Du har i øjeblikket åbnet en arkivdatabase for sæsonen {this.props.auth.database}. For at hente en backup af den primære database, skal du først returnere til standarddatabasen. Ønsker du at hente en backup af <b>arbivdatabase</b>?</span>, () => {
                                                           e.preventDefault();
                                                           document.getElementById('get-backup-form').submit();
                                                       });
                                                   }}>Hent backup</a>
                                            </form>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <a className="dashboard-link" href="#" title="Gendan database fra backup"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   this.setState({showRestoreFromBackupDialog: true})
                                               }
                                               }>Indlæs backup</a>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-separator"/> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <a className="dashboard-link" href="#" title="Start ny sæson"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   this.setState({showStartSeasonDialog: true})
                                               }
                                               }>Start sæson</a>
                                        </div> : null
                                    }
                                </td>
                                <td>
                                    {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id || this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id || this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <Link className="btn-primary" to={ROUTE_RACES}
                                                  title="Administrer kapflyvninger">
                                                Kapflyvninger
                                            </Link>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id || this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <Link className="btn-secondary"
                                                  to={ROUTE_ERROR_LISTS.replace(":subpage", "signups")}
                                                  title="Håndter fejllister">
                                                Fejllister
                                            </Link>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ?
                                        <div className="empty-container"/> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ?
                                        <div className="link-separator"/> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ?
                                        <div className="link-container">
                                            <a className="dashboard-link" href="#" title="Indlæs anmeldelser fra medlemsprogram"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   this.props.dispatch(AdminActions.getClub(this.props.auth.currentEntity));
                                                   if (!this.props.race.isRacesRead) this.props.dispatch(RaceActions.getRaces());
                                                   this.setState({showImportMemberProgramDialog: true})
                                               }
                                               }>Indlæs fra medlemsprogram</a>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ?
                                        <div className="link-container">
                                            <a className="dashboard-link" href="#" title="Indlæs anmeldelser og resultater fra elektroniske udstyr"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   //if (this.props.race.deviceImporterVersion === null || this.props.race.deviceImporterVersion === "-") {
                                                       const id = (moment().valueOf() + '-' + this.props.auth.id).slice(0, 25);
                                                       let cb = window.location.origin;
                                                       if (cb.slice(-1) !== '/') cb += '/';
                                                       cb += 'api/device-import/' + id;
                                                       this.props.dispatch(RaceActions.startDeviceImport(id, {
                                                           requestType: "version",
                                                           club: this.props.auth.currentEntity,
                                                       }, () => {
                                                           window.location.href = config.commUtility.url + "?callback=" + encodeURIComponent(cb) + "&command=version&id=" + encodeURIComponent(id);
                                                       }));
                                                   //}
                                                   this.setState({showImportDevicesDialog: true})
                                               }
                                               }>Indlæs fra udstyr</a>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ?
                                        <div className="link-container">
                                            <a className="dashboard-link" href="#" title="Send anmeldelser til DdB og sektion"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   if (!this.props.race.isRacesRead) this.props.dispatch(RaceActions.getRaces());
                                                   this.setState({showSendDialog: 'signup'});
                                               }
                                               }>Send anmeldelser</a>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ?
                                        <div className="link-container">
                                            <a className="dashboard-link" href="#" title="Send resultater til DdB og sektion"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   if (!this.props.race.isRacesRead) this.props.dispatch(RaceActions.getRaces());
                                                   this.setState({showSendDialog: 'result'});
                                               }
                                               }>Send resultater</a>
                                        </div> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <a className="dashboard-link" href="#"
                                               title="Fakturer foreningerne for deltagelse på kapflyvninger"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   this.setState({showRacesInvoiceDialog: true})
                                               }
                                               }>Fakturer kapflyvninger</a>
                                        </div> : null
                                    }
                                    {0 > 1 && this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ?
                                        <div className="link-container">
                                            <a className="dashboard-link" href="#"
                                               title="Benzing Basketing"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   client({
                                                       method: 'POST',
                                                       path: '/api/benzing/basketings',
                                                       entity: {
                                                           "race": {
                                                               "flight_id": 1767829001,
                                                               "race_number": 8,
                                                               "name": "0394",
                                                               "utc_offset": 7200,
                                                               "pigeon_count": {
                                                                   "basketing": 4,
                                                                   "arrival": 0
                                                               },
                                                               "release": {
                                                                   "time": "2026-01-13 21:38:07",
                                                                   "point": "Garlstorf",
                                                                   "distance": 0,
                                                                   "unit": "km",
                                                                   "latitude": 0,
                                                                   "longitude": 0
                                                               },
                                                               "devices": {
                                                                   "club": {
                                                                       "basketing": {
                                                                           "serial_number": "46900390",
                                                                           "name": "BENZING Live ClubSystem",
                                                                           "software_version": "4.4",
                                                                           "hardware_version": "2.3"
                                                                       }
                                                                   },
                                                                   "clock": {
                                                                       "serial_number": "402446",
                                                                       "name": "BENZING M3",
                                                                       "software_version": "1.18",
                                                                       "hardware_version": "2.5"
                                                                   }
                                                               },
                                                               "time_references": {
                                                                   "basketing": {
                                                                       "master_time": "2026-01-13 23:36:39",
                                                                       "clock_time": "2026-01-13 23:36:39"
                                                                   }
                                                               },
                                                               "fancier": {
                                                                   "name": "Tommy",
                                                                   "federation_id": "209001",
                                                                   "live_id": 226481,
                                                                   "country": "dk"
                                                               },
                                                               "pigeons": [
                                                                   {
                                                                       "country": "DK",
                                                                       "year": "2021",
                                                                       "sex": "f",
                                                                       "club": "209 ",
                                                                       "color": "    ",
                                                                       "ring_number": 2,
                                                                       "basketing": {
                                                                           "order": 1,
                                                                           "time": "2026-01-13T23:37:45+02:00",
                                                                           "electronic_chip_id": "DB030A22",
                                                                           "electronic_chip_uid": "9794BC1A",
                                                                           "nominated": 0,
                                                                           "meta_data": []
                                                                       }
                                                                   },
                                                                   {
                                                                       "country": "DK",
                                                                       "year": "2021",
                                                                       "sex": "f",
                                                                       "club": "209 ",
                                                                       "color": "    ",
                                                                       "ring_number": 3,
                                                                       "basketing": {
                                                                           "order": 2,
                                                                           "time": "2026-01-13T23:37:48+02:00",
                                                                           "electronic_chip_id": "DB030A1F",
                                                                           "electronic_chip_uid": "9794BC04",
                                                                           "nominated": 0,
                                                                           "meta_data": []
                                                                       }
                                                                   },
                                                                   {
                                                                       "country": "DK",
                                                                       "year": "2021",
                                                                       "sex": "m",
                                                                       "club": "209 ",
                                                                       "color": "    ",
                                                                       "ring_number": 9,
                                                                       "basketing": {
                                                                           "order": 3,
                                                                           "time": "2026-01-13T23:37:50+02:00",
                                                                           "electronic_chip_id": "DB030A05",
                                                                           "electronic_chip_uid": "9794BE47",
                                                                           "nominated": 0,
                                                                           "meta_data": []
                                                                       }
                                                                   },
                                                                   {
                                                                       "country": "DK",
                                                                       "year": "2021",
                                                                       "sex": "f",
                                                                       "club": "209 ",
                                                                       "color": "    ",
                                                                       "ring_number": 11,
                                                                       "basketing": {
                                                                           "order": 4,
                                                                           "time": "2026-01-13T23:37:54+02:00",
                                                                           "electronic_chip_id": "DB030A52",
                                                                           "electronic_chip_uid": "9794C02E",
                                                                           "nominated": 0,
                                                                           "meta_data": []
                                                                       }
                                                                   }
                                                               ],
                                                               "files": {
                                                                   "basketing": {
                                                                       "pdf": "https://download.benzing.live/basketinglists/dk/226481_1767829001.pdf",
                                                                       "csv": "https://download.benzing.live/export/dk/basketing_226481_1767829001.csv"
                                                                   }
                                                               },
                                                               "meta_data": []
                                                           }
                                                       },
                                                       headers: {'Content-Type': 'application/json'}
                                                   }).then(response => {
                                                       console.log('Success', response.entity);
                                                   }).catch(response => {
                                                       console.log('Error', response);
                                                   });
                                               }
                                               }>Benzing Basketing</a>
                                        </div> : null
                                    }
                                    {0 > 1 && this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ?
                                        <div className="link-container">
                                            <a className="dashboard-link" href="#"
                                               title="Benzing Arrival"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   client({
                                                       method: 'POST',
                                                       path: '/api/benzing/arrivals',
                                                       entity: {
                                                           "race": {
                                                               "flight_id": 1767652060,
                                                               "race_number": 5,
                                                               "name": "0394",
                                                               "fancier": {
                                                                   "name": "Tommy",
                                                                   "federation_id": "209001",
                                                                   "live_id": 226481,
                                                                   "country": "dk"
                                                               },
                                                               "pigeons": {
                                                                   "country": "DK",
                                                                   "year": "2021",
                                                                   "sex": "m",
                                                                   "club": "209 ",
                                                                   "color": "    ",
                                                                   "ring_number": 2,
                                                                   "arrival": {
                                                                       "order": 4,
                                                                       "time": "2026-01-13T23:26:12.087+02:00",
                                                                       "gps_time": 1767821171,
                                                                       "gps_latitude": 56.2155638,
                                                                       "gps_longitude": 9.8773805,
                                                                       "wrong_secret_number": false,
                                                                       "arrived_on": "Clock",
                                                                       "antenna_serial_number": "20501747",
                                                                       "meta_data": []
                                                                   }
                                                               }
                                                           }
                                                       },
                                                       headers: {'Content-Type': 'application/json'}
                                                   }).then(response => {
                                                       console.log('Success', response.entity);
                                                   }).catch(response => {
                                                       console.log('Error', response);
                                                   });
                                               }
                                               }>Benzing Arrival</a>
                                        </div> : null
                                    }
                                    {0 > 1 && this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ?
                                        <div className="link-container">
                                            <a className="dashboard-link" href="#"
                                               title="Benzing Evaluation"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   client({
                                                       method: 'POST',
                                                       path: '/api/benzing/strike-off',
                                                       entity: {
                                                           "race": {
                                                               "name": "0690",
                                                               "files": {
                                                                   "basketing": {
                                                                       "csv": "https://download.benzing.live/export/dk/basketing_226481_1770106269.csv",
                                                                       "pdf": "https://download.benzing.live/basketinglists/dk/226481_1770106269.pdf"
                                                                   },
                                                                   "evaluation": {
                                                                       "csv": "https://download.benzing.live/export/dk/evaluation_226481_1770106269.csv",
                                                                       "pdf": "https://download.benzing.live/evaluationlists/dk/226481_1770106269.pdf",
                                                                       "w_file": "https://download.benzing.live/w-file/dk/W0010205_226481_1770106269.d61",
                                                                       "winspeed": "https://download.benzing.live/winspeed/dk/W4020203446_1770106269_226481.d00"
                                                                   }
                                                               },
                                                               "devices": {
                                                                   "club": {
                                                                       "basketing": {
                                                                           "name": "BENZING Live ClubSystem",
                                                                           "serial_number": "46900390",
                                                                           "hardware_version": "2.3",
                                                                           "software_version": "4.5"
                                                                       },
                                                                       "evaluation": {
                                                                           "name": "BENZING Live ClubSystem",
                                                                           "serial_number": "46900390",
                                                                           "hardware_version": "2.3",
                                                                           "software_version": "4.5"
                                                                       }
                                                                   },
                                                                   "clock": {
                                                                       "name": "BENZING M3",
                                                                       "serial_number": "402446",
                                                                       "hardware_version": "2.5",
                                                                       "software_version": "1.18"
                                                                   }
                                                               },
                                                               "fancier": {
                                                                   "name": "HansHenrik Brøbech",
                                                                   "country": "dk",
                                                                   "live_id": 226481,
                                                                   "federation_id": "001026"
                                                               },
                                                               "pigeons": [
                                                                   {
                                                                       "sex": "f",
                                                                       "club": "073 ",
                                                                       "year": "2022",
                                                                       "color": "    ",
                                                                       "arrival": {
                                                                           "time": "2026-02-03T08:28:44.466+01:00",
                                                                           "order": 1,
                                                                           "gps_time": 1770103724,
                                                                           "meta_data": [],
                                                                           "arrived_on": "Clock",
                                                                           "gps_latitude": 56.2155277,
                                                                           "gps_longitude": 9.8774416,
                                                                           "wrong_secret_number": false,
                                                                           "antenna_serial_number": "20501747"
                                                                       },
                                                                       "country": "DK",
                                                                       "basketing": {
                                                                           "time": "2026-02-03T08:11:30+01:00",
                                                                           "order": 2,
                                                                           "nomination": 0,
                                                                           "electronic_chip_id": "DB030A52",
                                                                           "electronic_chip_uid": "9794C02E"
                                                                       },
                                                                       "ring_number": 770
                                                                   },
                                                                   {
                                                                       "sex": "f",
                                                                       "club": "073 ",
                                                                       "year": "2022",
                                                                       "color": "    ",
                                                                       "arrival": {
                                                                           "time": "2026-02-03T08:29:06.203+01:00",
                                                                           "order": 2,
                                                                           "gps_time": 1770103746,
                                                                           "meta_data": [],
                                                                           "arrived_on": "Clock",
                                                                           "gps_latitude": 56.2155277,
                                                                           "gps_longitude": 9.8774416,
                                                                           "wrong_secret_number": false,
                                                                           "antenna_serial_number": "20501747"
                                                                       },
                                                                       "country": "DK",
                                                                       "basketing": {
                                                                           "time": "2026-02-03T08:11:28+01:00",
                                                                           "order": 1,
                                                                           "nomination": 0,
                                                                           "electronic_chip_id": "DB030A22",
                                                                           "electronic_chip_uid": "9794BC1A"
                                                                       },
                                                                       "ring_number": 741
                                                                   }
                                                               ],
                                                               "release": {
                                                                   "time": "2026-02-03 11:24:22",
                                                                   "unit": "km",
                                                                   "point": "Heide",
                                                                   "distance": 0,
                                                                   "latitude": 0,
                                                                   "longitude": 0
                                                               },
                                                               "flight_id": 1770106269,
                                                               "meta_data": [],
                                                               "utc_offset": 3600,
                                                               "race_number": 17,
                                                               "pigeon_count": {
                                                                   "arrival": 2,
                                                                   "basketing": 2
                                                               },
                                                               "time_references": {
                                                                   "basketing": {
                                                                       "clock_time": "2026-02-03 06:11:04",
                                                                       "master_time": "2026-02-03 06:11:04"
                                                                   },
                                                                   "evaluation": {
                                                                       "clock_time": "2026-02-03 20:11:04",
                                                                       "master_time": "2026-02-03 20:11:04"
                                                                   }
                                                               }
                                                           }
                                                       },
                                                       headers: {'Content-Type': 'application/json'}
                                                   }).then(response => {
                                                       console.log('Success', response.entity);
                                                   }).catch(response => {
                                                       console.log('Error', response);
                                                   });
                                               }
                                               }>Benzing Evaluation</a>
                                        </div> : null
                                    }

                                </td>
                                <td>
                                    {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id || this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id || this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <Link className="btn-primary" to={ROUTE_CHAMPIONSHIPS}
                                                  title="Administrer mesterskaber">
                                                Mesterskaber
                                            </Link>
                                        </div> : null
                                    }
                                    {/*<div className="link-container">
                                        <Link className="btn-secondary" to={ROUTE_HOME} title="Administrer olympiade">
                                            OL
                                        </Link>
                                    </div>*/}
                                    <div className="empty-container"/>
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="empty-container"/> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-separator"/> : null
                                    }
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <a className="dashboard-link" href="#" title="Eksporter statistik"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   this.setState({showExportDialog: 'ddb-stat'})
                                               }
                                               }>Eksporter statistik</a>
                                        </div> : null
                                    }
                                    {/*this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ?
                                        <div className="link-container">
                                            <a className="dashboard-link" href="#" title="Importer sektionsstatistik"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   this.setState({showImportDialog: 'section-stat'})
                                               }
                                               }>Indlæs sektionsstatistik</a>
                                        </div> : null
                                    */}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {/*(this.props.auth.currentRole !== UserRoles.MAIN_ADMIN.id) || */(!this.props.admin.archives || this.props.admin.archives.length === 0) ? null : <div className="lower-left">
                        <label htmlFor="select-database">Database</label>
                        <UserFieldElement dataType={UserFieldDataType.enum} placeholder={false} className="field100p"
                                          name="select-database" id="select-database" value={this.props.auth.database}
                                          options={[{key: 'standard', value: 'Standard'}].concat(this.props.admin.archives.map(db => ({key: db, value: db})))}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={(e) => {
                                              const db = e.target.value;
                                              this.props.dispatch(AdminActions.selectDatabase(db, () => {
                                                  NotificationManager.success('Du har nu skiftet til ' + (db === 'standard' ? 'standarddatabasen.' : 'databasen for sæson ' + db + '.'), 'Database', 4000);
                                              }));
                                          }}
                         />
                    </div>}
                    <Link to={ROUTE_REPORTING.replace(":category", "general").replace(":report", "members")} className="lower-right dashboard-icon" title="Rapportgenerering"><i className="fa fa-print"/></Link>
                </div>
                {this.state.showExportDevicesDialog !== false ? <ExportDevicesDialog onClose={() => {this.setState({showExportDevicesDialog: false})}} /> : null}
                {this.state.showExportDialog !== false ? <ExportDialog exportType = {this.state.showExportDialog} onClose={() => {this.setState({showExportDialog: false})}} onSuccess={() => {}} /> : null}
                {this.state.showImportDialog !== false ? <ImportFilesDialog importType = {this.state.showImportDialog} onClose={() => {this.setState({showImportDialog: false})}} onSuccess={() => {}} /> : null}
                {this.state.showRacesInvoiceDialog !== false ? <RacesInvoiceDialog onClose={() => {this.setState({showRacesInvoiceDialog: false})}} onSuccess={() => {}} /> : null}
                {this.state.showRestoreFromBackupDialog !== false ? <RestoreFromBackupDialog onClose={() => {this.setState({showRestoreFromBackupDialog: false})}} /> : null}
                {this.state.showStartSeasonDialog !== false ? <StartSeasonDialog onClose={() => {this.setState({showStartSeasonDialog: false})}} /> : null}
                {this.state.showImportMemberProgramDialog !== false ? <ImportMemberProgramDialog onClose={() => {this.setState({showImportMemberProgramDialog: false})}} onSuccess={() => {}} /> : null}
                {this.state.showImportDevicesDialog !== false ? <ImportDevicesDialog onClose={() => {this.setState({showImportDevicesDialog: false})}} onSuccess={() => {}} /> : null}
                {this.state.showSendDialog !== false ? <ExportSignupsAndResultsDialog exportType = {this.state.showSendDialog} onClose={() => {this.setState({showSendDialog: false})}} onSuccess={() => {}} /> : null}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: {
        isAuthenticated: state.auth.isAuthenticated,
        isMainAdmin: state.auth.isMainAdmin,
        isSectionAdmin: state.auth.isSectionAdmin,
        isClubAdmin: state.auth.isClubAdmin,
        id: state.auth.id,
        clubNumber: state.auth.clubNumber,
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
        database: state.auth.database,
    },
    admin: {
        archives: state.admin.archives,
        userRoles: state.admin.userRoles,
    },
    race: {
        isRacesRead: state.race.isRacesRead,
        deviceImports: state.race.deviceImports,
        deviceImporterVersion: state.race.deviceImporterVersion,
    }
});

export default connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/home/Dashboard.js